import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withHandlers, withProps, withState } from 'recompose';

import getInitialValues from './getInitialValues';
import { getUserUrlPrefix } from '../../../../auth/selectors';
import withNotifications from '../../../../common/withNotifications';
import withOwnerTypeAndId from '../../../../common/hoc/withOwnerTypeAndId';
import { productsProviderV2 as productsProvider } from '../../../../products/products/hoc/productsProvider';
import poVendorsProvider from '../../vendors/hoc/poVendorsProvider';
import withProducts from '../../../products/hoc/withProducts';
import withLoadingList from '../../../../common/hoc/withLoaingList';
import { poFormValueSelector } from '../SharedPoForm/formConfig';
import {
  validateOrder,
  generateOrder,
  downloadOrderPdf,
} from '../actions';

const AddPoFormContainer = compose(
  withRouter,
  withNotifications,
  productsProvider,
  withProducts,
  poVendorsProvider({ onlyEnabled: true }),
  connect(
    (state) => {
      const productQuantities = poFormValueSelector(state, 'products') || {};
      return {
        baseUrl: `${getUserUrlPrefix(state)}/products`,
        orderedProducts: Object.entries(productQuantities)
          .filter(([, value]) => !!value.quantity)
          .map(([id, value]) => ({
            productId: id,
            quantity: value.quantity,
          })),
      };
    },
  ),
  withState('busy', 'setBusy', false),
  withState('isValidatingOrder', 'setIsValidating', false),
  withState('orders', 'setOrders', []),
  withState('canDownloadPdf', 'setCanDownloadPdf', false),
  withState('isOrderGenerated', 'setIsOrderGenerated', false),
  withLoadingList(
    () => ({ length: 1 }), // hack to ignore branch for empty array
  ),
  withProps((props) => {
    return ({
      initialValues: getInitialValues(props.products),
    });
  }),
  withOwnerTypeAndId,
  withHandlers({
    submitOrder: props => async () => {
      props.setBusy(true);

      const payload = {
        orders: props.orders.map(order => ({
          id: order.id,
          vendorId: order.vendorId,
        })),
      };

      try {
        const order = await generateOrder(props.ownerId, payload);
        props.addNotification({
          title: 'Success',
          level: 'success',
          message: 'Purchase order successfully saved!',
        });

        props.setCanDownloadPdf(true);
        props.setIsOrderGenerated(true);

        return order;
      } catch (error) {
        return null;
      } finally {
        props.setBusy(false);
      }
    },
    validateOrder: props => async () => {
      props.setIsValidating(true);
      props.setCanDownloadPdf(false);

      const payload = { orders: props.orderedProducts };

      try {
        const validatedData = await validateOrder(props.ownerId, payload);
        props.setOrders(validatedData.orders);
      } catch (error) {
        // nothing to see here, just making eslint happy
      } finally {
        props.setIsValidating(false);
      }
    },
    downloadPdf: props => (order) => {
      downloadOrderPdf(props.ownerId, order);
    },
  }),
);

export default AddPoFormContainer;
